import AddIcon from "@mui/icons-material/Add";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Grid, IconButton, MenuItem, Stack, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GlobalButton from "../../../components/button";
import CustomRangePicker from "../../../components/dateRange";
import DynamicTable from "../../../components/dynamicTable";
import AppHeader from "../../../components/header";
import AppLoader from "../../../components/loader";
import PerformanceGraphs from "../../../components/performanceGraph";
import CustomDropDown from "../../../components/select";
import StatsCard from "../../../components/statsCard";
import { AppContext } from "../../../lib/Context";
import {
  resetDashboardSearchFilter,
  resetDashboardSearchFilterSaver,
  setDashboardEndDate,
  setDashboardEndDateSaver,
  setDashboardStartDate,
  setDashboardStartDateSaver,
  setSelectedCardStatus,
  setSelectedCardStatusSaver,
} from "../../../lib/redux/slices/searchKeysSlice";
import { getAgentDashboard } from "../../../services/DashboardApi";
import { handleOpenSnackBar } from "../../../utils/helper";
import moment from "moment";
import { setPhoneValidation } from "../../../lib/redux/slices/phoneValidationSlice";
import { setSignedDate } from "../../../lib/redux/slices/signedDateSlice";

const tableHeader = [
  "Prospect Details",
  "Connect Details",
  "Sale Value",
  "Status",
  "Sale Status",
  "Detail",
];

const displayRows = [
  "customer_details",
  "connectDetails",
  "paymentDetails",
  "contract_status",
  "saleStatus",
  "actions",
];

const AgentSaverDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const { userData, handleResetData } = useContext(AppContext);
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);

  useEffect(() => {
    if (userData) {
      fetchAgentDashboard(
        userData._id,
        searchKeys?.dashboardStartDateSaver,
        searchKeys?.dashboardEndDateSaver,
        searchKeys?.selectedCardStatusSaver,
      );
    }
  }, [userData, searchKeys?.selectedCardStatusSaver]);

  // Get Dashboard Data
  const fetchAgentDashboard = async (id, sd, ed, searchBy) => {
    let query = {
      startDate: sd.toISOString(),
      endDate: ed.toISOString(),
      pricingMode: "buy",
    };
    try {
      setIsLoading(true);
      const response = await getAgentDashboard(id, query, searchBy);
      if (response?.data.status === "success") {
        let data = response?.data.data;
        setDashboardData(data);
      } else {
        handleOpenSnackBar("error", response?.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterDate = () => {
    fetchAgentDashboard(
      userData._id,
      searchKeys?.dashboardStartDateSaver,
      searchKeys?.dashboardEndDateSaver,
      searchKeys?.selectedCardStatusSaver,
    );
  };

  const handleResetFilter = () => {
    dispatch(resetDashboardSearchFilterSaver());
    fetchAgentDashboard(
      userData._id,
      moment(new Date()),
      moment(new Date()),
      searchKeys?.selectedCardStatusSaver,
    );
  };

  let cardsData = [
    {
      id: 1,
      title: "Signed",
      count: dashboardData?.totalSignedContracts || 0,
      type: "signedContract",
    },
    {
      id: 2,
      title: "GP Sold",
      count: `£${dashboardData?.totalProfit || 0}`,
      type: "gpSold",
    },

    // {
    //   id: 3,
    //   title: "GP In Provisioning",
    //   count: `£${dashboardData?.gpInProvisioning || 0}`,
    //   type: "gpProvisioning",
    // },

    // {
    //   id: 4,
    //   title: "GP Lost",
    //   count: `£${dashboardData?.gpLoss || 0}`,
    //   type: "gpLost",
    // },

    {
      id: 5,
      title: "Total Live Sales",
      count: dashboardData?.totalLiveSale || 0,
      type: "liveSales",
    },

    {
      id: 6,
      title: "GP Live",
      count: `£${dashboardData?.totalNetProfit || 0}`,
      type: "gpLive",
    },
    // {
    //   id: 7,
    //   title: "Rework",
    //   count: `${dashboardData?.gpInRework || 0}`,
    //   type: "gpInRework",
    // },

    // {
    //   id: 8,
    //   title: "Sales Lost",
    //   count: `${dashboardData?.salesLost || 0}`,
    //   type: "salesLost",
    // },

    // {
    //   id: 9,
    //   title: "Contracts Sent",
    //   count: dashboardData?.totalContracts || 0,
    //   type: "sendContract",
    // },

    // {
    //   id: 10,
    //   title: "GP Live to Target",
    //   count: `${dashboardData?.netProfitTargetPercentage || 0}%`,
    //   type: "gpLiveToTarget",
    // },

    // {
    //   id: 11,
    //   title: "GP Lost %",
    //   count: `${dashboardData?.gpLossTargetPercentage || 0}%`,
    //   type: "gpLostPercent",
    // },
  ];

  const handleNavigateToDetail = (row, index) => {
    navigate("/prospect-details", { state: { data: row } });
  };

  return (
    <AppHeader>
      <AppLoader isVisible={isLoading} />
      <Stack
        p={2}
        direction={"row"}
        mb={3}
        spacing={1}
        bgcolor={"primary.light"}
        alignItems={"center"}
      >
        <CustomRangePicker
          startDate={searchKeys?.dashboardStartDateSaver}
          endDate={searchKeys?.dashboardEndDateSaver}
          setStartDate={(start) => dispatch(setDashboardStartDateSaver(start))}
          setEndDate={(start) => dispatch(setDashboardEndDateSaver(start))}
          handleFilterDate={handleFilterDate}
          stackProps={{
            boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
            borderRadius: "6px",
          }}
        />
        <IconButton
          onClick={handleResetFilter}
          sx={{
            borderRadius: "10px",
            background: (theme) => theme.palette.gradient.button,
            height: 50,
            width: 50,
          }}
        >
          <RestartAltIcon htmlColor="white" />
        </IconButton>
      </Stack>
      <Grid container rowSpacing={2} columnSpacing={6}>
        {cardsData.map((itemmm) => {
          return (
            <Grid key={itemmm.id} item xs={12} sm={6} md={3}>
              <StatsCard title={itemmm.title} valueCount={itemmm.count} />
            </Grid>
          );
        })}
      </Grid>
      <PerformanceGraphs
        totalConn={61}
        profitValue={"259.00"}
        dashboardData={dashboardData}
      />
      <Stack
        my={2}
        px={1}
        py={2}
        gap={2}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        bgcolor={"primary.light"}
        flexWrap={"wrap"}
      >
        <Stack direction={{ sm: "row" }} alignItems={"center"} gap={2}>
          <Typography
            variant={"body2"}
            fontSize={"0.75rem"}
            color={"secondary.dark"}
          >
            Prospects ({dashboardData?.allContracts?.length})
          </Typography>

          <CustomDropDown
            value={searchKeys?.selectedCardStatusSaver}
            onChange={(e) => dispatch(setSelectedCardStatusSaver(e.target.value))}
            size={"small"}
            stylePropos={{
              width: "250px",
              "& .MuiInputBase-root": {
                backgroundColor: "white",
              },
            }}
          >
            {/* <MenuItem value={searchBy}>All</MenuItem> */}
            {cardsData.map((val) => {
              return (
                <MenuItem key={val.id} value={val.type}>
                  {`${val.title}  (${val.count})`}
                </MenuItem>
              );
            })}
          </CustomDropDown>
        </Stack>

        <GlobalButton
          variant={"custom_gradient"}
          title={"Add Lead"}
          startIcon={<AddIcon />}
          handleClickBtn={() => {
            navigate("/add-lead");
            handleResetData(true);
            dispatch(setPhoneValidation(null));
            dispatch(setSignedDate(null));
          }}
          style={{
            width: 130,
            borderRadius: "100px",
          }}
        />
      </Stack>

      <DynamicTable
        tableData={dashboardData?.allContracts || []}
        displayRows={displayRows}
        tableHeader={tableHeader}
        showDetail={true}
        handleNavigateToDetail={handleNavigateToDetail}
      />
    </AppHeader>
  );
};

export default AgentSaverDashboard;
